import { useState } from "react";
import { toast } from "react-toastify";
import { Formik } from "formik";
import { object, string } from "yup";
import { Button, Col, FormGroup, Input, Label, Modal, ModalBody, ModalHeader, Row } from "reactstrap";

import { CloseButton } from "components/CloseButton";
import { MySpinner } from "components/MySpinner";
import { SelectSearch } from "components/SelectSearch";
import { brandsSuggestion, createCross, getCrossByArticleBrand, updateCross } from "services/api";

const CrossSchema = object().shape({
  article: string().required(),
  brand: object().required()
});

export const UpdateCrossModal = ({
  ids,
  openModal,
  setOpenModal,
  getAndSetCross,
  setSelected
}) => {
  const [loading, setLoading] = useState(false);
  const [analogueCode, setAnalogueCode] = useState(false);

  //Получение нового analogueCode
  const crossHandler = (values, resetForm) => {
    setLoading(true);
    getCrossByArticleBrand({
      article: values.article,
      brand: values.brand.label,
    })
      .then((res) => {
        if (!res.length) {
          toast.error('Не найден код аналога');
          return;
        }
        setAnalogueCode(res[0].analogueCode?.id);

        updateCrossHandler(res[0].analogueCode?.id);
      })
      .catch((e) => console.error(e))
      .finally(() => setLoading(false));
  };

  const updateCrossHandler = (analogueCode) => {
    setLoading(true);
    updateCross({
      ids,
      analogueCodeId: analogueCode
    })
      .then(() => {
        toast.success("Кроссы успешно перенесены на артикул");
        getAndSetCross();
        setSelected([]);
      })
      .catch((e) => {
        toast.error(e.response?.data?.message);
        setLoading(false);
      });
  }

  return (
    <Modal
      isOpen={openModal}
      toggle={() => setOpenModal(false)}
    >
      {loading && <MySpinner overlay />}
      <ModalHeader>
        <div className="modal-title-text">Перенос кроссов на другой артикул </div>
        <CloseButton onClick={() => setOpenModal(false)} />
      </ModalHeader>
      <ModalBody className="m-3">
        <Formik
          initialValues={{
            article: "",
            brand: null,
          }}
          validationSchema={CrossSchema}
          onSubmit={(values, { setSubmitting, resetForm }) => {
            crossHandler(values, resetForm);
            setSubmitting(false);
          }}
          enableReinitialize
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
            setFieldValue,
          }) => (
            <form onSubmit={handleSubmit}>
              <Row className="main-info">
                <Col>
                  <FormGroup>
                    <Label>Артикул</Label>
                    <Input
                      id="article"
                      label="Артикул"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.article}
                      invalid={
                        errors.article && touched.article ? errors.article : null
                      }
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row className="main-info">
                <Col>
                  <FormGroup>
                    <Label>Бренд</Label>
                    <SelectSearch
                      name="brand"
                      placeholder="Выберите бренд"
                      functionSuggestion={brandsSuggestion}
                      value={values.brand}
                      setValue={val => setFieldValue("brand", val)}
                      isClearable
                      invalid={
                        errors.brand && touched.brand ? errors.brand : null
                      }
                    />
                  </FormGroup>
                </Col>
              </Row>
              <div className="d-flex justify-content-end">
                <Button type="submit" color="primary" className="mr-2">
                  Добавить
                </Button>
                <Button type="button" onClick={() => setOpenModal(false)} color="secondary">
                  Закрыть
                </Button>
              </div>
            </form>
          )}
        </Formik>
      </ModalBody>
    </Modal>
  );
};
